import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getPageCssDevRequest = {};
var _getPageCssDevResponse = {};
var _getPageCssRequest = {};
var _getPageCssResponse = {};
function resolveWixVeloCssV1CssDevServiceUrl(opts) {
    var domainToMappings = {
        'editor._base_domain_': [
            {
                srcPath: '/_api/cloud-css-dev-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/cloud-css-dev-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/cloud-css-dev-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/cloud-css-dev-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixVeloCssV1CssServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/cloud-css-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/cloud-css-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** returns an object with css content for the requested page id */
export function getPageCss(payload) {
    var _a = serializer(_getPageCssRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPageCssResponse, {}).fromJSON;
    function __getPageCss(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.velo.css.v1.page_css',
            method: 'GET',
            methodFqn: 'wix.velo.css.v1.CssService.GetPageCss',
            url: resolveWixVeloCssV1CssServiceUrl({
                protoPath: '/v1/apps/{gridAppId}/pages/{pageId}/css',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPageCss.fromReq = fromReq;
    return __getPageCss;
}
/** returns an object with css content for the requested page id */
export function getPageCssDev(payload) {
    var _a = serializer(_getPageCssDevRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPageCssDevResponse, {}).fromJSON;
    function __getPageCssDev(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.velo.css.v1.page_css',
            method: 'GET',
            methodFqn: 'wix.velo.css.v1.CssDevService.GetPageCssDev',
            url: resolveWixVeloCssV1CssDevServiceUrl({
                protoPath: '/v1/apps/{gridAppId}/pages/{pageId}/css',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPageCssDev.fromReq = fromReq;
    return __getPageCssDev;
}
//# sourceMappingURL=http.impl.js.map